export const companiesData = [
  

{
    id: 1,
    rank: 1,
    name: "Lucky Core Industries Limited",
    slug: "lucky-core-industries-limited",
    country: "Pakistan",
    sector: "Chemical",
    AntiCorruptionProgrammes: 80.0,
    OrganisationalTransparency: 91.67,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 94.33,
    description:
      "Lucky Core Industries Limited is a publicly listed company, engaged in five diverse businesses: Polyester, Soda Ash, Chemicals & Agri Sciences, Pharmaceuticals and Animal Health."
      ,
    stats: {
antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Percentages owned in each of them", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true, 2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", isSub: true, 2025: "", 2024: "N/A" },

    { indicator: "Percentages owned in each of them", isSub: true, 2025: "", 2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "", 2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "", 2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },

  {
    id: 2,
    rank: 2,
    name: "Allied Bank Limited",
    slug: "allied-bank-limited",
    country: "Pakistan",
    sector: "Commercial Banks",
    AntiCorruptionProgrammes: 83.33,
    OrganisationalTransparency: 87.5,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 94.17,
    description:
      "Allied Bank Limited is a scheduled Bank, engaged in commercial banking and related services.",
    stats: {
      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Percentages owned in each of them", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true, 2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", isSub: true, 2025: "", 2024: "N/A" },

    { indicator: "Percentages owned in each of them", isSub: true, 2025: "", 2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "", 2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "", 2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 3,
    rank: 3,
    name: "Oil & Gas Development Company Limited",
    slug: "oil-gas-development-company-limited",
    country: "Pakistan",
    sector: "Oil and Gas Exploration Companies",
    AntiCorruptionProgrammes: 70.0,
    OrganisationalTransparency: 95.45,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 93.09,
    description:
      "Oil and Gas Development Company Limited was established to undertake exploration and development of oil and gas resources, including production and sale of oil and gas and related activities formerly carried on by Oil and Gas Development Corporation, established in 1961."
      ,
    stats: {
      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Percentages owned in each of them", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true, 2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Percentages owned in each of them", isSub: true, 2025: "", 2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "", 2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "50%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "", 2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 4,
    rank: 4,
    name: "Engro Corporation Limited",
    slug: "engro-corporation-limited",
    country: "Pakistan",
    sector: "Fertilizer",
    AntiCorruptionProgrammes: 83.33,
    OrganisationalTransparency: 91.67,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 90.0,
    AverageScoresofEachCompany: 93.0,
    description:
      "Engro Corporation Limited is a public listed company and is a subsidiary of Dawood Hercules Corporation Limited. The principal activity of the Company is to manage investments in subsidiary companies, associated companies and joint venture, engaged in fertilizers, power generation, telecommunications infrastructure, petrochemicals, mining, food, LNG and chemical storages."
,
    stats: {


      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "10 0%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "50%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "50%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }
      
    }
  },
  {
    id: 5,
    rank: 5,
    name: "MCB Bank Limited",
    slug: "mcb-bank-limited",
    country: "Pakistan",
    sector: "Commercial Banks",
    AntiCorruptionProgrammes: 86.67,
    OrganisationalTransparency: 91.67,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 80.0,
    AverageScoresofEachCompany: 91.67,
    description:
      "MCB Bank Limited is a banking company incorporated in Pakistan and is engaged in commercial banking and related services."
,
    stats: {

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    } 
    }
  },
  {
    id: 6,
    rank: 6,
    name: "Mari Petroleum Company Limited",
    slug: "mari-petroleum-company-limited",
    country: "Pakistan",
    sector: "Oil and Gas Exploration Companies",
    AntiCorruptionProgrammes: 56.67,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 91.33,
    description:
      "Mari Energies Limited is a public limited company. It is principally engaged in the exploration, production, and sale of hydrocarbons. It also provides exploration and production-related services and is involved in ventures related to mineral mining and technology businesses."
,
    stats: {
antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "100%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 7,
    rank: 6,
    name: "Sazgar Engineering Works Limited",
    slug: "sazgar-engineering-works-limited",
    country: "Pakistan",
    sector: "Automobile Assembler",
    AntiCorruptionProgrammes: 76.67,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 80.0,
    AverageScoresofEachCompany: 91.33,
    description:
      "Sazgar Engineering Works Limited converted into a Public Limited Company on November 21, 1994, and is engaged in the manufacture and sale of automobiles, automotive parts and household electric appliances. "
,
    stats: {
      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "100%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 8,
    rank: 8,
    name: "Packages Limited",
    slug: "packages-limited",
    country: "Pakistan",
    sector: "Paper, Board and Packaging",
    AntiCorruptionProgrammes: 63.33,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 90.67,
    description:
      "Packages Limited is a public limited company incorporated in Pakistan. It is principally engaged in the manufacture and sale of packaging materials and tissue products. "
,
    stats: {


      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
      
    }
  },
  
  
  
  
  
  
  
  
  
  
  
  {
    id: 9,
     rank: 9,
    name: "Unilever Pakistan Foods Limited",
    slug: "unilever-pakistan-foods-limited",
    country: "Pakistan",
    sector: "Food & Personal Care Products",
    AverageScoresofEachCompany: 90.67,
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 100,
    DomesticFinancialReporting: 100,
    GenderAndNonDiscriminationPolicies: 100,
    HumanRightsAndCorporateResponsibility: 100,
    description:
      "Unilever Pakistan Foods Limited operates in the Food & Personal Care Products sector and is recognized for its transparency and corporate responsibility.",
    stats: {
     

      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    },
  
    },


    {
    id: 10,
    rank: 10,
    name: "Colgate-Palmolive (Pakistan) Limited",
    slug: "colgate-palmolive-pakistan-limited",
    country: "Pakistan",
    sector: "Food & Personal Care Products",
    AntiCorruptionProgrammes: 90.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 60.0,
    AverageScoresofEachCompany: 88.0,
    description:
      "Colgate-Palmolive (Pakistan) Limited was incorporated in Pakistan on December 5, 1977, and is mainly engaged in the manufacture and sale of detergents, personal care and other related products."
,
    stats: {

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
    }
  },


  {
    id: 11,
    rank: 10,
    name: "Fauji Fertilizer Company Limited",
    slug: "fauji-fertilizer-company-limited",
    country: "Pakistan",
    sector: "Fertilizer",
    AntiCorruptionProgrammes: 56.67,
    OrganisationalTransparency: 83.33,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 88.0,
    description:
      "Fauji Fertilizer Company Limited is a public company. The principal activity of the Company is manufacturing, purchasing and marketing of fertilizers and chemicals, including investment in other fertilizer, chemical, cement, energy generation, food processing and banking operations."
,
    stats: {

      
       antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "50%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "50%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 12,
    rank: 12,
    name: "Haleon Pakistan Limited",
    slug: "haleon-pakistan-limited",
    country: "Pakistan",
    sector: "Pharmaceutical",
    AntiCorruptionProgrammes: 76.67,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 90.0,
    AverageScoresofEachCompany: 86.33,
    description:
      "Haleon Pakistan Limited (formerly known as GlaxoSmithKline Consumer Healthcare Pakistan Limited) was incorporated in Pakistan as a public listed company on 31 March."
,
    stats: {
      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }
     
    }
  },
  {
    id: 13,
    rank: 12,
    name: "Lucky Cement Limited",
    slug: "lucky-cement-limited",
    country: "Pakistan",
    sector: "Cement",
    AntiCorruptionProgrammes: 40.0,
    OrganisationalTransparency: 91.67,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 86.33,
    description:
      "Lucky Cement Limited was incorporated in Pakistan on September 18, 1993. The principal activity of the Company is manufacturing and marketing of cement."
,
    stats: {


      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "100%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 14,
    rank: 12,
    name: "Pakistan Tobacco Company Limited",
    slug: "pakistan-tobacco-company-limited",
    country: "Pakistan",
    sector: "Tobacco",
    AntiCorruptionProgrammes: 66.67,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 86.33,
    description:
      "Pakistan Tobacco Company Limited is a public limited company incorporated in Pakistan on November 18, 1947. The Company is engaged in the manufacture and sale of cigarettes/ tobacco."
,
    stats: {

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
      

    }
  },
  {
    id: 15,
    rank: 15,
    name: "GlaxoSmithKline Pakistan Limited",
    slug: "glaxosmithkline-pakistan-limited",
    country: "Pakistan",
    sector: "Pharmaceutical",
    AntiCorruptionProgrammes: 70.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 90.0,
    AverageScoresofEachCompany: 85.0,
    description:
      "GlaxoSmithKline Consumer Healthcare Pakistan Limited was incorporated in Pakistan on March 31, 2015. The Company is engaged in manufacturing, marketing and sale of consumer healthcare products. "
,
    stats: {
        antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }
     
    }
  },
  {
    id: 16,
    rank: 15,
    name: "United Bank Limited",
    slug: "united-bank-limited",
    country: "Pakistan",
    sector: "Commercial Banks",
    AntiCorruptionProgrammes: 63.33,
    OrganisationalTransparency: 91.67,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 80.0,
    AverageScoresofEachCompany: 85.0,
    description:
      "United Bank Limited is a banking company incorporated in Pakistan and is engaged in commercial banking and related services. "
,
    stats: {

    antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 17,
    rank: 17,
    name: "Kohat Cement Company Limited",
    slug: "kohat-cement-company-limited",
    country: "Pakistan",
    sector: "Cement",
    AntiCorruptionProgrammes: 60.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 60.0,
    AverageScoresofEachCompany: 84.0,
    description:
      "Kohat Cement Company Limited is a public limited company, engaged in the production and sale of cement."
,
    stats: {
antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
      
    }
  },
  {
    id: 18,
    rank: 18,
    name: "Attock Refinery Limited",
    slug: "attock-refinery-limited",
    country: "Pakistan",
    sector: "Refinery",
    AntiCorruptionProgrammes: 43.33,
    OrganisationalTransparency: 83.33,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 83.33,
    description:
      "Attock Refinery Limited was incorporated as a public company on June 26, 1979. It is principally engaged in the refining of crude oil."
,
    stats: {


      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "50%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "50%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
      
    }
  },
  {
    id: 19,
    rank: 19,
    name: "Nestle Pakistan Limited",
    slug: "nestle-pakistan-limited",
    country: "Pakistan",
    sector: "Food & Personal Care Products",
    AntiCorruptionProgrammes: 80.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 60.0,
    AverageScoresofEachCompany: 83.0,
    description:
      "Nestlé Pakistan Limited is a public limited company engaged in manufacturing, processing and sale of dairy, nutrition, beverages and food products including imported products."
,
    stats: {
      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
    }
  },
  {
    id: 20,
    rank: 20,
    name: "Pakistan Petroleum Limited",
    slug: "pakistan-petroleum-limited",
    country: "Pakistan",
    sector: "Oil and Gas Exploration Companies",
    AntiCorruptionProgrammes: 43.33,
    OrganisationalTransparency: 91.67,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 82.0,
    description:
      "Pakistan Petroleum Limited was incorporated in Pakistan in 1950 with the main objectives of conducting exploration, prospecting, development and production of oil and natural gas resources."
,
    stats: {

        

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "100%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
        
    }
  },


  {
    id: 21,
    rank: 21,
    name: "Maple Leaf Cement Factory Limited",
    slug: "maple-leaf-cement-factory-limited",
    country: "Pakistan",
    sector: "Cement",
    AntiCorruptionProgrammes: 40.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 81.0,
    description:
      "Maple Leaf Cement Factory Limited was incorporated in Pakistan on 13 April 1960. The principal activity of the Company is production and sale of cement."
,
    stats: {


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
      
    }
  },


  {
    id: 22,
    rank: 22,
    name: "Air Link Communication Limited",
    slug: "air-link-communication-limited",
    country: "Pakistan",
    sector: "Technology & Communication",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 80.67,
    description:
      "Air Link Communication Limited imports, exports distribution, identing wholesale retail of communication and IT-related products and services including cellular mobile/smart phones, tablets, laptops accessories and allied products. "
,
    stats: {


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


    }
  },



  {
    id: 23,
    rank: 22,
    name: "Atlas Honda Limited",
    slug: "atlas-honda-limited",
    country: "Pakistan",
    sector: "Automobile Assembler",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 75.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 50.0,
    AverageScoresofEachCompany: 80.67,
    description:
      "Atlas Honda Limited was incorporated as a public limited company on October 16, 1962 and is principally engaged in progressive manufacturing and marketing of motorcycles and spare parts."
,
    stats: {


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "50%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }

     
    }
  },



  
    {
    id: 24,
    rank: 24,
    name: "Abbott Laboratories (Pakistan) Limited",
    slug: "abbott-laboratories-pakistan-limited",
    country: "Pakistan",
    sector: "Pharmaceuticals",
    AntiCorruptionProgrammes: 56.67,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 80.0,
    AverageScoresofEachCompany: 80.33,
    description:
      "Abbott Laboratories Pakistan Limited, incorporated in 1948, is a public limited company engaged in the manufacturing, import, and marketing of pharmaceutical and healthcare products."
,
    stats: {

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


    },
  },

{
    "id": 25,
    "rank": 26,
    "name": "Philip Morris (Pakistan) Limited",
    "slug": "philip-morris-pakistan-limited",
    "country": "Pakistan",
    "sector": "Tobacco",
    "AntiCorruptionProgrammes": 80.0,
    "OrganisationalTransparency": 100.0,
    "DomesticFinancialReporting": 90.0,
    "GenderAndNonDiscriminationPolicies": 50.0,
    "HumanRightsAndCorporateResponsibility": 80.0,
    "AverageScoresofEachCompany": 80.0,
    "description":
      "Philip Morris Pakistan Limited, incorporated in 2011, is a public limited company engaged in the manufacturing and sale of cigarettes and tobacco products.",
    stats: {

      


      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "50%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "50%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
      
    }
  },

{
  "id": 27,
  "rank": 27,
  "name": "Cherat Cement Company Limited",
  "slug": "cherat-cement-company-limited",
  "country": "Pakistan",
  "sector": "Cement",
  "AntiCorruptionProgrammes": 46.67,
  "OrganisationalTransparency": 100.0,
  "DomesticFinancialReporting": 90.0,
  "GenderAndNonDiscriminationPolicies": 100.0,
  "HumanRightsAndCorporateResponsibility": 60.0,
  "AverageScoresofEachCompany": 79.33,
  "description": "Cherat Cement Company Limited, incorporated in 1981, is a public limited company engaged in the manufacturing and sale of cement.",
  "stats": {

    antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
  }
},


  {
    id: 28,
    rank: 28,
    name: "Attock Petroleum Limited",
    slug: "attock-petroleum-limited",
    country: "Pakistan",
    sector: "Oil & Gas Marketing Companies",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 87.5,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 60.0,
    AverageScoresofEachCompany: 78.17,
    description:
      "Attock Petroleum Limited, incorporated in 1995, is a public limited company engaged in the procurement, storage, and marketing of petroleum and related products."
,

    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }

     
    },
  },



  {
    id: 29,
    rank: 29,
    name: "Kot Addu Power Company Limited",
    slug: "kot-addu-power-company-limited",
    country: "Pakistan",
    sector: "Power Generation & Distribution",
    AntiCorruptionProgrammes: 60.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 40.0,
    AverageScoresofEachCompany: 78.0,
    description:
      "Kot Addu Power Company Limited, incorporated in 1996, is a public limited company engaged in power generation and sale of electricity to WAPDA. "
,

    stats: {

      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "50%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


    },
  },


  {
    id: 30,
    rank: 30,
    name: "AGP Limited",
    slug: "agp-limited",
    country: "Pakistan",
    sector: "Pharmaceuticals",
    AntiCorruptionProgrammes: 66.67,
    OrganisationalTransparency: 87.5,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 70.0,
    AverageScoresofEachCompany: 77.83,
    description:
      "AGP Limited, incorporated in 2014, is a public limited company engaged in the manufacturing, import, distribution, and marketing of pharmaceutical products. "
,
    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }

    },
  },
  {
    id: 31,
    rank: 31,
    name: "Frieslandcampina Engro Pakistan Limited",
    slug: "frieslandcampina-engro-pakistan-limited",
    country: "Pakistan",
    sector: "Food & Personal Care Products",
    AntiCorruptionProgrammes: 60.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 80.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 70.0,
    AverageScoresofEachCompany: 77.0,
    description:
      "FrieslandCampina Engro Pakistan Limited, incorporated in Pakistan, is a public limited company engaged in the manufacturing and sale of dairy products and frozen desserts."
,
    stats: {
        

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "50%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }





    },
  },
  {
    id: 32,
    rank: 32,
    name: "Standard Chartered Bank (Pak) Ltd",
    slug: "standard-chartered-bank-pak-ltd",
    country: "Pakistan",
    sector: "Commercial Banks",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 50.0,
    HumanRightsAndCorporateResponsibility: 80.0,
    AverageScoresofEachCompany: 76.67,
    description:
      "Standard Chartered Bank Pakistan Limited, incorporated in 2006, is a scheduled bank engaged in commercial banking and related financial services. "
,
    stats: {

      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }

    },
  },


  {
    id: 33,
    rank: 32,
    name: "Interloop Limited",
    slug: "interloop-limited",
    country: "Pakistan",
    sector: "Textile Composite",
    AntiCorruptionProgrammes: 33.33,
    OrganisationalTransparency: 75.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 76.67,
    description:
      "Interloop Limited, incorporated in 1992, is a public limited company engaged in the manufacturing and export of textile and apparel products."
,
    stats: {

      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }

      
    },
  },


  {
    id: 34,
    rank: 34,
    name: "Honda Atlas Cars (Pakistan) Limited",
    slug: "honda-atlas-cars-pakistan-limited",
    country: "Pakistan",
    sector: "Automobile Assembler",
    AntiCorruptionProgrammes: 40.0,
    OrganisationalTransparency: 87.5,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 90.0,
    AverageScoresofEachCompany: 76.5,
    description:
      "Honda Atlas Cars Pakistan Limited, incorporated in 1992, is a public limited company engaged in the assembling, manufacturing, and sale of motor vehicles. "
,
    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "50%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "5  0%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "50%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }


    },
  },



  {
    id: 35,
    rank: 35,
    name: "K-Electric Limited",
    slug: "k-electric-limited",
    country: "Pakistan",
    sector: "Power Generation & Distribution",
    AntiCorruptionProgrammes: 56.67,
    OrganisationalTransparency: 75.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 50.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 76.33,
    description:
      "K Electric Limited, incorporated in 1913, is a public limited company engaged in the generation, transmission, and distribution of electric power."
,
    stats: {

     


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "0%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }



    },
  },



  {
    id: 36,
    rank: 36,
    name: "Pakistan State Oil Company Limited",
    slug: "pakistan-state-oil-company-limited",
    country: "Pakistan",
    sector: "Oil & Gas Marketing Companies",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 91.67,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 60.0,
    AverageScoresofEachCompany: 76.0,
    description:
      "Pakistan State Oil Company Limited, incorporated in 1976, is a public limited company engaged in the procurement, storage, and marketing of petroleum products."
,
    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "50%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "50%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }



     
    },
  },



  {
    id: 37,
    rank: 37,
    name: "Pakistan Telecommunication Company Ltd",
    slug: "pakistan-telecommunication-company-ltd",
    country: "Pakistan",
    sector: "Technology & Communication",
    AntiCorruptionProgrammes: 73.33,
    OrganisationalTransparency: 75.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 40.0,
    AverageScoresofEachCompany: 75.67,
    description:
      "Pakistan Telecommunication Company Limited, incorporated in 1995, is a public limited company engaged in the provision of telecommunication services."
,
    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "0%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "50%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


    },
  },



  {
    id: 38,
    rank: 38,
    name: "The Hub Power Company Limited",
    slug: "the-hub-power-company-limited",
    country: "Pakistan",
    sector: "Power Generation & Distribution",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 40.0,
    AverageScoresofEachCompany: 73.67,
    description:
      "The Hub Power Company Limited, incorporated in 1991, is a public limited company engaged in the development and operation of power generation facilities."
,
    stats: {

        

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "100%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }



    },
  },


  {
    id: 39,
    rank: 39,
    name: "Feroze1888 Mills Limited",
    slug: "feroze1888-mills-limited",
    country: "Pakistan",
    sector: "Textile Composite",
    AntiCorruptionProgrammes: 40.0,
    OrganisationalTransparency: 87.5,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 50.0,
    HumanRightsAndCorporateResponsibility: 100.0,
    AverageScoresofEachCompany: 73.50,
    description:
      "Feroze1888 Mills Limited was incorporated in Pakistan as a Public Limited Company in October 1972 . The Company is principally engaged in the production and export of towels. "
,
    stats: {

      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }


    },
  },





  {
    id: 40,
    rank: 40,
    name: "Indus Motor Company Limited",
    slug: "indus-motor-company-limited",
    country: "Pakistan",
    sector: "Automobile Assembler",
    AntiCorruptionProgrammes: 33.33,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 50.0,
    HumanRightsAndCorporateResponsibility: 80.0,
    AverageScoresofEachCompany: 72.67,
    description:
      "Indus Motor Company Limited, incorporated in 1989, is a public limited company engaged in the assembling, manufacturing, and marketing of motor vehicles. "
,
    stats: {



      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }

     
    },
  },



  {
    id: 41,
    rank: 40,
    name: "Sui Northern Gas Pipelines Limited",
    slug: "sui-northern-gas-pipelines-limited",
    country: "Pakistan",
    sector: "Oil & Gas Marketing Companies",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 20.0,
    AverageScoresofEachCompany: 72.67,
    description:
      "Sui Northern Gas Pipelines Limited, incorporated under the Companies Act, is a public limited company engaged in the transmission and distribution of natural gas. "
,
    stats: {

     


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }


    },
  },
  {
    id: 42,
    rank: 42,
    name: "Fauji Cement Company Limited",
    slug: "fauji-cement-company-limited",
    country: "Pakistan",
    sector: "Cement",
    AntiCorruptionProgrammes: 36.67,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 50.0,
    AverageScoresofEachCompany: 72.33,
    description:
      "Fauji Cement Company Limited, incorporated in 1992, is a public limited company engaged in the manufacturing and sale of cement.",
    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "50%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "50%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }

      
    },
  },
  {
    id: 43,
    rank: 43,
    name: "Pioneer Cement Limited",
    slug: "pioneer-cement-limited",
    country: "Pakistan",
    sector: "Cement",
    AntiCorruptionProgrammes: 20.0,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 100.0,
    HumanRightsAndCorporateResponsibility: 50.0,
    AverageScoresofEachCompany: 72.00,
    description:
      "Pioneer Cement Limited, incorporated in 1986, is a public limited company engaged in the manufacturing and sale of cement. ",
    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "50%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }


    },
  },
  {
    id: 44,
    rank: 44,
    name: "Ismail Industries Limited",
    slug: "ismail-industries-limited",
    country: "Pakistan",
    sector: "Food & Personal Care Products",
    AntiCorruptionProgrammes: 60.0,
    OrganisationalTransparency: 79.17,
    DomesticFinancialReporting: 90.0,
    GenderAndNonDiscriminationPolicies: 50.0,
    HumanRightsAndCorporateResponsibility: 80.0,
    AverageScoresofEachCompany: 71.83,
    description:
      "Ismail Industries Limited, incorporated in 1988, is a public limited company engaged in the manufacturing and trading of food and packaging products.",
    stats: {



      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "50%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }

     
    },
  },
  {
    id: 45,
    rank: 45,
    name: "Pak Elektron Limited",
    slug: "pak-elektron-limited",
    country: "Pakistan",
    sector: "Cable & Electrical Goods",
    AntiCorruptionProgrammes: 53.33,
    OrganisationalTransparency: 100.0,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 50.0,
    HumanRightsAndCorporateResponsibility: 50.0,
    AverageScoresofEachCompany: 70.67,
    description:
      "Pak Elektron Limited, incorporated in 1956, is a public limited company engaged in the manufacturing and sale of electrical and electronic products.",
    stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


         
    },
  },



  {
    id: 46,
    rank: 46,
    name: "Service Industries Limited",
    slug: "service-industries-limited",
    country: "Pakistan",
    sector: "Leather & Tanneries",
    AntiCorruptionProgrammes: 26.67,
    OrganisationalTransparency: 81.25,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 60.0,
    AverageScoresofEachCompany: 68.58,
    description:
      "Service Industries Limited, incorporated in 1957, is a public limited company engaged in the manufacturing and sale of footwear, tyres, and rubber products. ",
    stats: {


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "0%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
      



    },
  },



  {
    id: 47,
    rank: 47,
    name: "Systems Limited",
    slug: "systems-limited",
    country: "Pakistan",
    sector: "Technology & Communication",
    AntiCorruptionProgrammes: 26.67,
    OrganisationalTransparency: 79.17,
    DomesticFinancialReporting: 100.0,
    GenderAndNonDiscriminationPolicies: 75.0,
    HumanRightsAndCorporateResponsibility: 60.0,
    AverageScoresofEachCompany: 68.17,
    description:
      "Systems Limited, incorporated in 2017, is a public limited company engaged in software development and information technology services. ",
    stats: {
 antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "0%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
      

     
    },
  }
  ,

   {
    id: 48,
    rank: 48,
    sector: "Commercial Banks",
    name: "Habib Bank Limited",
    description: "Habib Bank Limited is engaged in commercial banking-related services in Pakistan and overseas.",
    AntiCorruptionProgrammes: 50.00,
    OrganisationalTransparency: 87.50,
    DomesticFinancialReporting: 100.00,
    GenderAndNonDiscriminationPolicies: 75.00,
    HumanRightsAndCorporateResponsibility: 20.00,
    AverageScoresofEachCompany: 66.50,
    description:
      "Habib Bank Limited is engaged in commercial banking-related services in Pakistan and overseas. ",
    stats: {

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "50%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }
     
  }
}




,
{
  id: 49,
  rank: 49,
  sector: "Fertilizer",
  name: "Fatima Fertilizer Company Limited",
  description: "Fatima Fertilizer Company Limited was incorporated in Pakistan on December 24, 2003 and is involved in manufacturing, producing, importing and exporting fertilizers and chemicals.",
  AntiCorruptionProgrammes: 36.67,
  OrganisationalTransparency: 93.75,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 50.00,
  HumanRightsAndCorporateResponsibility: 50.00,
  AverageScoresofEachCompany: 66.08,
  description:
      "Fatima Fertilizer Company Limited was incorporated in Pakistan on December 24, 2003 and is involved in manufacturing, producing, buying, selling, importing and exporting fertilizers and chemicals.",
  stats: {



    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "50%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }
    
  }
}
,
{
  id: 50,
  rank: 50,
  sector: "Hospitality",
  name: "Pakistan Services Limited",
  description: "Pakistan Services Limited is principally engaged in the hotel business and owns and manages Pearl Continental Hotels.",
  AntiCorruptionProgrammes: 36.67,
  OrganisationalTransparency: 100.00,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 100.00,
  HumanRightsAndCorporateResponsibility: 0.00,
  AverageScoresofEachCompany: 65.33,
  description:
      " Pakistan Services Limited is principally engaged in the hotel business and owns and manages the chain of Pearl Continental Hotels. The Company also owns one small sized property in Lahore operating under the budget hotel concept. The Company also grants franchise to use its trade mark and name “Pearl Continental”.",
  stats: {


    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "100%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
    
  }
}



,
{
  id: 51,
  rank: 51,
  sector: "Inv. Banks / Inv. Cos. / Securities Cos.",
  name: "Dawood Hercules Corporation Limited",
  description: "Dawood Hercules Corporation Limited (now known as Engro Holdings Limited) is principally engaged in managing investments.",
  AntiCorruptionProgrammes: 50.00,
  OrganisationalTransparency: 75.00,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 75.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 64.00,
  description:
      "Dawood Hercules Coporation Limited (now known as Engro Holdings Limited) is principally engaged in managing investments including in its subsidiaries and associated companies. ",

  stats: {
    


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "50%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "50%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


  }
}




,
{
  id: 52,
  rank: 52,
  sector: "Food & Personal Care Products",
  name: "National Foods Limited",
  description: "The National Foods Limited is principally engaged in the manufacture and sale of convenience-based food products.",
  AntiCorruptionProgrammes: 40.00,
  OrganisationalTransparency: 100.00,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 25.00,
  HumanRightsAndCorporateResponsibility: 60.00,
  AverageScoresofEachCompany: 63.00,
  description:
      "The National Foods Limited is principally engaged in the manufacture and sale of convenience-based food products. ",
  stats: {

    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "50%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }


  }
}



,
{
  id: 53,
  rank: 53,
  sector: "Commercial Banks",
  name: "Meezan Bank Limited",
  description: "Meezan Bank Limited is engaged in corporate, commercial, consumer, investment and retail banking activities.",
  AntiCorruptionProgrammes: 56.67,
  OrganisationalTransparency: 70.83,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 50.00,
  HumanRightsAndCorporateResponsibility: 40.00,
  AverageScoresofEachCompany: 61.50,
  description:
      "Meezan Bank Limited is engaged in corporate, commercial, consumer, investment and retail banking activities.",
  stats: {
     




    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "50%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "100%"
        }
      ]
    }

    }
  },
  



{
  id: 54,
  rank: 54,
  sector: "Transport",
  name: "Pakistan National Shipping Corporation",
  description: "PNSC is principally engaged in the business of shipping, including charter of vessels, transportation of cargo and other related services and providing commercial, technical, administrative, financial and other services to its subsidiaries and third parties in relation to the business of shipping. The Corporation is also engaged in renting out its properties to tenants under lease arrangements.",
  AntiCorruptionProgrammes: 16.67,
  OrganisationalTransparency: 83.33,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 75.00,
  HumanRightsAndCorporateResponsibility: 30.00,
  AverageScoresofEachCompany: 61.00,
  stats: {




      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }

    
  }
}



,
{
  id: 55,
  rank: 55,
  sector: "Engineering",
  name: "Mughal Iron & Steel Industries Limited",
  description: " Mughal Iron and Steel Industries Limited’s operations comprise ferrous and nonferrous business segments. Also, the principal activity of the Company is manufacturing and sale of mild steel products relating to ferrous segment.",
  AntiCorruptionProgrammes: 43.33,
  OrganisationalTransparency: 75.00,
  DomesticFinancialReporting: 80.00,
  GenderAndNonDiscriminationPolicies: 75.00,
  HumanRightsAndCorporateResponsibility: 30.00,
  AverageScoresofEachCompany: 60.67,
  stats: {



    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }
    
  }
}




,
{
  id: 56,
  rank: 56,
  sector: "Oil & Gas Exploration Companies",
  name: "Pakistan Oilfields Limited",
  description: "The POL is principally engaged in exploration, drilling and production of crude oil and gas in Pakistan. Its activities also include marketing of liquefied petroleum gas under the brand name POLGAS and transmission of petroleum.",
  AntiCorruptionProgrammes: 26.67,
  OrganisationalTransparency: 75.00,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 50.00,
  HumanRightsAndCorporateResponsibility: 60.00,
  AverageScoresofEachCompany: 60.33,
  stats: {

   

    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "0%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }




  }
}



,
{
  id: 57,
  rank: 57,
  sector: "Automobile Assembler",
  name: "Millat Tractors Limited",
  description: "Millat Tractors Limited is principally engaged in assembling and manufacturing of agricultural tractors, implements and multiapplication products. The Company is also involved in the sale, implementation and support of IFS applications in Pakistan and abroad.",
  AntiCorruptionProgrammes: 40.00,
  OrganisationalTransparency: 100.00,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 25.00,
  HumanRightsAndCorporateResponsibility: 30.00,
  AverageScoresofEachCompany: 59.00,
  stats: {

    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "100%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }
  }
}



,
{
  id: 58,
  rank: 58,
  sector: "Automobile Parts & Accessories",
  name: "Thal Limited",
  description: "Thal Limited is engaged in the manufacture of jute goods, engineering goods, papersack and laminate sheets.",
  AntiCorruptionProgrammes: 20.00,
  OrganisationalTransparency: 70.83,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 75.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 57.17,
  stats: {

 

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "100%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "50%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }

  }
}
,



{
  id: 59,
  rank: 59,
  sector: "Glass & Ceramic",
  name: "Ghani Glass Limited",
  description: "Ghani Glass Limited is engaged in the business of manufacturing and sale of glass containers and float glass.",
  AntiCorruptionProgrammes: 3.33,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 50.00,
  HumanRightsAndCorporateResponsibility: 40.00,
  AverageScoresofEachCompany: 56.17,
  stats: {
      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "50%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
   
  }
}




,
{
  id: 60,
  rank: 60,
  sector: "Commercial Banks",
  name: "National Bank of Pakistan",
  description: "The NBP is engaged in providing commercial banking and related services in Pakistan and Overseas. The Bank also handles treasury transactions for the Government of Pakistan (GoP) as an agent to the State Bank of Pakistan.",
  AntiCorruptionProgrammes: 40.00,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 50.00,
  HumanRightsAndCorporateResponsibility: 0.00,
  AverageScoresofEachCompany: 53.50,
  stats: {

    

    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "100%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "50%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }



  }
}



,
{
  id: 61,
  rank: 61,
  sector: "Textile Composite",
  name: "Sapphire Fibres Limited",
  description: "Sapphire Fibres Limited is principally engaged in manufacturing and sale of yarn, fabrics and garments.",
  AntiCorruptionProgrammes: 43.33,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 25.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 53.17,
  stats: {


    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "100%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "50%"
        }
      ]
    }

  }
}




,
{
  id: 62,
  rank: 62,
  sector: "Sugar & Allied Industries",
  name: "JDW Sugar Mills Limited",
  description: "The JDW Sugar Mills Limited is principally engaged in the production and sale of crystalline sugar, electricity and managing corporate farms.",
  AntiCorruptionProgrammes: 23.33,
  OrganisationalTransparency: 91.67,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 25.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 50.00,
  stats: {

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
    
  }
}



,
{
  id: 63,
  rank: 63,
  sector: "Synthetic & Rayon",
  name: "Ibrahim Fibres Limited",
  description: "The principal business of the Ibrahim Fibres Limited is to manufacture and sell polyester staple fibre and yarn.",
  AntiCorruptionProgrammes: 10.00,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 25.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 46.50,
  stats: {

    


      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "No"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "0%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


  }
}




,
{
  id: 64,
  rank: 64,
  sector: "Pharmaceuticals",
  name: "The Searle Company Limited",
  description: "The Searle Company Limited is principally engaged in the manufacture of pharmaceutical and other consumer products. International Brands (Private) Limited is the Parent Company, which holds 56.32% shareholding in the Company.",
  AntiCorruptionProgrammes: 13.33,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 0.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 42.17,
  stats: {


    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "No"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "0%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
    
    
  }
}
,




{
  id: 65,
  rank: 65,
  sector: "Cement",
  name: "Bestway Cement Limited",
  description: "Bestway Cement Limited is principally engaged in production and sale of cement.",
  AntiCorruptionProgrammes: 23.33,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 0.00,
  HumanRightsAndCorporateResponsibility: 0.00,
  AverageScoresofEachCompany: 42.17,
  stats: {



    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "100%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }


  }
}




,
{
  id: 66,
  rank: 66,
  sector: "Technology & Communication",
  name: "TRG Pakistan Limited",
  description: "TRG Pakistan Limited's principal activity is through its associate, The Resource Group International Limited (TRGIL), to invest in a portfolio of investments primarily in the Technology, IT enabled services and medicare insurance sectors.",
  AntiCorruptionProgrammes: 22.22,
  OrganisationalTransparency: 81.50,
  DomesticFinancialReporting: 100.00,
  GenderAndNonDiscriminationPolicies: 0.00,
  HumanRightsAndCorporateResponsibility: 0.00,
  AverageScoresofEachCompany: 40.69,
  stats: {

    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "100%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }



  }
}


,
{
  id: 67,
  rank: 67,
  sector: "Miscellaneous",
  name: "Pakistan Aluminium Beverage Cans Limited",
  description: "Pakistan Aluminium Beverage Cans Limited's principal activity is manufacturing and sale of aluminium cans.",
  AntiCorruptionProgrammes: 3.33,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 80.00,
  GenderAndNonDiscriminationPolicies: 0.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 38.17,
  stats: {

   

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "N/A0%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }



  }
}





,
{
  id: 68,
  rank: 68,
  sector: "Food & Personal Care Products",
  name: "Rafhan Maize Products Company Limited",
  description: "Rafhan Maize Products Company Limited uses maize as the basic raw material to manufacture and sell a number of industrial products, principal ones being industrial starches, liquid glucose, dextrose, dextrin and gluten meals.",
  AntiCorruptionProgrammes: 0.00,
  OrganisationalTransparency: 87.50,
  DomesticFinancialReporting: 70.00,
  GenderAndNonDiscriminationPolicies: 0.00,
  HumanRightsAndCorporateResponsibility: 20.00,
  AverageScoresofEachCompany: 35.50,
  stats: {



    

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "N/A" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "N/A" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "N/A" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "N/A" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "N/A" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "N/A" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "50%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }
   
  }
}
 ,




{
  id: 69,
  rank: 69,
  sector: "Pharmaceuticals",
  name: "Highnoon Laboratories Limited",
  description: "Highnoon Laboratories Limited is principally engaged in the manufacture, import, sale and marketing of pharmaceutical and related consumer products.",
  AntiCorruptionProgrammes: 0.00,
  OrganisationalTransparency: 62.50,
  DomesticFinancialReporting: 90.00,
  GenderAndNonDiscriminationPolicies: 0.00,
  HumanRightsAndCorporateResponsibility: 0.00,
  AverageScoresofEachCompany: 30.50,
  stats: {


      

      

      antiCorruption: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company publicly commit to be in compliance with all relevant laws, including anti-corruption laws?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company leadership (Chairperson/ CEO/Member of the board of directors) demonstrate support for anti-corruption?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s code of conduct / anti-corruption policy explicitly apply to all employees and directors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company’s anti-corruption policy explicitly apply to persons who are not employees but are authorised to act on behalf of the company or represent it (for example: agents, advisors, representatives or intermediaries)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company require external entities that provide goods or services under contract (for example: contractors, subcontractors, suppliers) to abide by the company’s anti corruption programme or supplier code?",
          2025: "",
          2024: "50%"
        }
        ,
        {
          indicator: "Does the company have in place an anti corruption training programme for its employees and directors?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on gifts, hospitality, and expenses?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the policy on gifts, hospitality or expenses include a definition of thresholds (descriptive or quoted as amounts) as well as procedures and reporting requirements?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Is there a policy that explicitly prohibits facilitation payments?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the company provide a mechanism/ channel through which employees can report suspected acts of corruption or breaches of anti-corruption policies, and does the mechanism/channel allow for confidential and/or anonymous reporting (whistle blowing)?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the whistle-blowing mechanism/ channel enable employees and others to raise concerns and report suspected acts of corruption or breaches of anti-corruption policies without risk of reprisal?",
          2025: "",
          2024: "0%"
        }
        ,
        {
          indicator: "Does the mechanism/channel provide for two-way communication with the whistle blower for any needed follow-up on the concern/s raised?",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company carry out regular or continuous monitoring of its anti-corruption programme/policy to review its suitability, adequacy and effectiveness, and implement improvements as appropriate?                                                                    If the company reviews and monitors its anti corruption programme/policy at least once a year, it would be considered as regular or continuous monitoring",
          2025: "",
          2024: "0%"
        }
         ,
        {
          indicator: "Does the company have a policy on political contributions that either prohibits such contributions or if it does not, requires such contributions to be publicly disclosed?",
          2025: "",
          2024: "0%"
        }
      ]
    },
    organizationalTransparency: {
  tableData: [
    {
      indicator: "Does the company disclose its ultimate beneficial owner/s? *",
      2025: "",
      2024: "Yes"
    },

    // GROUP 1: Fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its fully consolidated subsidiaries?"
    },
    { indicator: "The full list with names",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
      isSub: true,
      2025: "", 
      2024: "100%" },

    { indicator: "Countries of incorporation (for each entity) The place of incorporation is the principal address of the corporation in the state where it’s incorporated/registered.",
       isSub: true,
       2025: "", 
       2024: "100%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true,
        2025: "", 
        2024: "0%" },

    // GROUP 2: Non-fully consolidated subsidiaries
    {
      isGroup: true,
      indicator: "Which of the following information does the company disclose for all of its non-fully consolidated subsidiaries? such as associates, joint-ventures, etc"
    },
    { indicator: "The full list with names", 
      isSub: true, 
      2025: "",
      2024: "100%" },

    { indicator: "Percentages owned in each of them",
       isSub: true,
        2025: "",
        2024: "0%" },

    { indicator: "As per SECP's Code of Corporate Governance, has the company developed and disseminated a formal Code of Conduct that promotes ethical culture and prevents conflicts of interest for directors, senior management, and employees?",
    isSub: true, 2025: "",
     2024: "0%" },

    { indicator: "Countries of operations (for each entity) A multinational corporation (MNC) is a company that has business operations in at least one country other than its home country. Countries in which it conducts business aside from the home country are considered to be countries of operations.",
       isSub: true, 
       2025: "",
      2024: "0%" },

    // NORMAL
    { indicator: "Does the company disclose that its auditors have undergone a quality assurance review under ICAP’s Quality Control Review program and confirm compliance with the ICAP Code of Ethics and the ethical standards set by IFAC?",
       2025: "",
      2024: "100%" },
    { indicator: "Has the company ensured compliance with SECP’s Code of Corporate Governance by prohibiting the appointment of external auditors and their associated entities as internal auditors?",
       2025: "",
        2024: "100%" },

    { indicator: "Does the company adhere to mandatory regulations and apply the 'comply or explain' approach for non-mandatory provisions, as outlined in SECP’s Code of Corporate Governance?",
       2025: "",
        2024: "100%" },
    { indicator: "Has the company, in accordance with SECP's Code of Corporate Governance, developed and disseminated a formal Code of Conduct that fosters an ethical culture and prevents conflicts of interest?",
       2025: "",
      2024: "100%" }
  ]
},
    domesticFinancialReporting: {
      tableData: [
        {
          indicator: "Does the company disclose its revenue/sales in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator:
            "Does the company disclose its capital expenditure in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its pre-tax income in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the company disclose its income tax in Pakistan?",
          2025: "",
          2024: "100%"
        },
        {
          indicator: "Does the Company disclose its community contribution (Corporate Social Responsibility programmes) in Pakistan?",
          2025: "",
          2024: "50%"
        }
      ]
    },

    genderAndNonDiscrimination: {
      tableData: [
        {
          indicator:
            "Does the company have an explicit publicly stated commitment against sexual harassment?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive/equal opportunity recruitment policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company adopt a gender inclusive promotion policy?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have an explicit, publicly stated commitment to non-discrimination based on gender?",
          2025: "",
          2024: "0%"
        }
      ]
    },

    procurementReporting: {
      tableData: [
        {
          indicator: "Does the company have a policy for bidding on government contracts/tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose its current contracts with local and/or foreign governments?",
          2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company publish tendering and post award documents for government contracts and awarded tenders?",
           2025: "",
          2024: "N/A"
        },
        {
          indicator: "Does the company disclose audited financial accounts for government contracts and awarded tenders?",
          2025: "",
          2024: "N/A"
        }
      ]
    },

    humanRightsAndResponsibility: {
      tableData: [
        {
          indicator: "Has the company implemented human rights due diligence processes in its operations, including its supply chains, in line with national legislation and international standards?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Does the company have mechanisms to prevent forced labor, child labor, and other forms of modern slavery in its operations and supply chains?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "Does the company have policies and frameworks that ensure occupational health and safety for all employees, especially in high-risk sectors?",
          2025: "",
          2024: "0%"
        },
        {
          indicator: "Are effective grievance mechanisms available for employees and other stakeholders to report human rights abuses or workplace violations, with access to timely and fair remedies?",
          2025: "",
          2024: "0%"
        },
        {
          indicator:
            "As per SECP guidelines, does the company actively promote best practices in Environmental, Social, and Corporate Governance (ESG), while ensuring commitment to sustainable and responsible operations?",
          2025: "",
          2024: "0%"
        }
      ]
    }

    
      }
}

  

  

];



